import React from "react";
import { User } from "./api";

interface UserContextValue {
  user: User | null;
  setUser: (user: User) => void;
  logout: () => void;
}

export const UserContext = React.createContext<UserContextValue | null>(null);